import { Component, inject, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { DatePipe } from '../../../pipes/date.pipe';
import { CurrentUserService } from '../../../services/currentUser.service';

@Component({
  selector: 'repairer-status-bar',
  imports: [NgTemplateOutlet, DatePipe],
  template: `
    @if (repairer().status === 'SUSPENDED') {
      <div class="min-h-40 rounded-[4px] mb-15 flex justify-center items-center bg-red text-white">
        Suspended
        @if (repairer().licenseSuspendedDate) {
          &nbsp;&nbsp;
          <span class="font-semibold text-16">{{ repairer().licenseSuspendedDate | dateepoch: timezone }}</span>
        }
      </div>
    } @else if (repairer().unpaidLicense) {
      <div class="p-10 rounded-[4px] mb-20 flex justify-around items-center bg-[#f9ebd5] text-charcoal">
        <ng-container
          *ngTemplateOutlet="
            readonlyText;
            context: { label: 'License Flagged', value: repairer().licenseFlaggedDate | dateepoch: timezone }
          " />
        <ng-container
          *ngTemplateOutlet="
            readonlyText;
            context: { label: 'Invoice Number', value: repairer().licenseInvoiceNumber }
          " />
        <ng-container
          *ngTemplateOutlet="readonlyText; context: { label: 'Due Date', value: repairer().licenseDueDate }" />
        <ng-container
          *ngTemplateOutlet="
            readonlyText;
            context: { label: 'Suspension Date', value: repairer().licenseSuspensionDate }
          " />
      </div>
    }

    <ng-template #readonlyText let-label="label" let-value="value">
      <div class="flex flex-col">
        <span>{{ label }}</span>
        <span class="font-semibold text-16 min-h-20">{{ value ?? '' }}</span>
      </div>
    </ng-template>
  `
})
export class RepairerStatusBarComponent {
  repairer = input.required<any>();
  timezone = inject(CurrentUserService).timeZone;
}
